export enum NotificationType {
  ReservationReminderEmail = "reservationReminderEmail",
  ReservationReminderSms = "reservationReminderSms",
  FruitReviewNotification = "fruitReviewNotification",
  RecipesNotification = "recipesNotification",
  OrderPickupReminder = "orderPickupReminder",
  Newsletter = "newsletter",
}
